var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Palette = function Palette(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 20 20' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M10.932 15.005h1.682v-1.667h-1.682v1.667zm.841-3.334c-1.393 0-2.523 1.12-2.523 2.5a2.512 2.512 0 0 0 2.523 2.501c1.393 0 2.523-1.12 2.523-2.5 0-1.381-1.13-2.501-2.523-2.501zm-6.728.833h1.682v-1.667H5.045v1.667zm.84-3.334c-1.392 0-2.522 1.12-2.522 2.5 0 1.381 1.13 2.501 2.523 2.501 1.392 0 2.523-1.12 2.523-2.5S7.279 9.17 5.886 9.17zm.842-2.501h1.682V5.002H6.727v1.667zm.84 1.667c1.394 0 2.524-1.12 2.524-2.5a2.513 2.513 0 0 0-2.523-2.502c-1.393 0-2.523 1.12-2.523 2.501 0 1.38 1.13 2.501 2.523 2.501zm10.73 3.47a8.323 8.323 0 0 1-4.335 5.59 8.391 8.391 0 0 1-3.863.937c-3.159 0-6.023-1.726-7.477-4.503C.492 9.747 2.106 4.707 6.22 2.594a8.344 8.344 0 0 1 3.85-.933c.664 0 1.332.08 1.981.235a.84.84 0 0 1 .583.5.829.829 0 0 1-.072.762 4.897 4.897 0 0 0-.789 2.669c0 2.758 2.263 5.002 5.046 5.002.19 0 .377-.012.562-.032.27-.03.54.07.72.27a.83.83 0 0 1 .196.74zm1.056-1.853a2.55 2.55 0 0 0-2.162-.812c-.12.012-.246.02-.372.02-1.854 0-3.364-1.496-3.364-3.334 0-.63.181-1.241.522-1.769a2.49 2.49 0 0 0 .22-2.282 2.519 2.519 0 0 0-1.75-1.5 10.209 10.209 0 0 0-7 .837A10.002 10.002 0 0 0 0 10.004a9.873 9.873 0 0 0 1.13 4.594C2.872 17.93 6.31 20 10.1 20c1.602 0 3.204-.39 4.635-1.124a9.989 9.989 0 0 0 5.206-6.708 2.492 2.492 0 0 0-.588-2.215z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Palette;
//# sourceMappingURL=Palette.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Palette.js